// @ts-nocheck
import componentsReducer, { BunzlComponentsActions } from "@store/Framework/Store/Bunzl/Components/ComponentsReducer";
import pagesReducer, { BunzlPagesActions } from "@store/Framework/Store/Bunzl/Pages/PagesReducer";
import "@toolkit/Framework/Store";
import { combineReducers } from "redux";

const bunzlReducers = combineReducers({
    components: componentsReducer,
    pages: pagesReducer,
});

export type BunzlActions = BunzlComponentsActions | BunzlPagesActions;
export default bunzlReducers;
